import { createFileRoute } from "@tanstack/react-router";
import { ApiKeyList } from "@/features/apiKeys/ApiKeyList";

export const Route = createFileRoute("/_layout/api-keys")({
  component: ApiKeyList,
});
